var SpriteSymbol = require("../../node_modules/svg-baker-runtime/browser-symbol.js");
var sprite = require("../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js");
var symbol = new SpriteSymbol({
  "id": "close_new",
  "use": "close_new-usage",
  "viewBox": "0 0 16 16",
  "content": "<symbol viewBox=\"0 0 16 16\" xmlns=\"http://www.w3.org/2000/svg\" id=\"close_new\">\n    <path fill-rule=\"evenodd\" clip-rule=\"evenodd\" d=\"M12.992 2c-.268 0-.525.106-.714.296L8 6.574 3.722 2.296a1.009 1.009 0 1 0-1.427 1.427L6.573 8l-4.278 4.277a1.01 1.01 0 0 0 1.427 1.428L8 9.428l4.278 4.277a1.009 1.009 0 1 0 1.427-1.427L9.427 8.002l4.278-4.278A1.01 1.01 0 0 0 12.992 2Z\" />\n</symbol>"
});
var result = sprite.add(symbol);
module.exports = symbol